import { render, staticRenderFns } from "./wiki-view-drawer.vue?vue&type=template&id=6cb18450"
import script from "./wiki-view-drawer.vue?vue&type=script&lang=js"
export * from "./wiki-view-drawer.vue?vue&type=script&lang=js"
import style0 from "./wiki-view-drawer.vue?vue&type=style&index=0&id=6cb18450&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports